export default "__VITE_ASSET__C16IsXjm__"